/**
 * A stable colour for any unit type, with no table to maintain.
 *
 * The rexine app keeps a switch statement per known unit type; it had to be
 * edited for 'tannery' and would need editing again for every vertical after.
 * Hashing the name onto a fixed palette gives every value — including ones that
 * do not exist yet — the same colour every time, everywhere it is shown.
 */
const PALETTE = [
  '#1890ff', // blue
  '#722ed1', // purple
  '#52c41a', // green
  '#fa8c16', // orange
  '#13c2c2', // cyan
  '#eb2f96', // magenta
  '#2f54eb', // geekblue
  '#a0d911', // lime
];

export function unitTypeColor(unitType: string | null | undefined): string {
  const key = (unitType ?? '').trim().toLowerCase();
  if (!key) return '#8c8c8c';
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}

/** 'tannery' → 'Tannery'; shown wherever the raw discriminator would look like code. */
export function unitTypeLabel(unitType: string | null | undefined): string {
  const key = (unitType ?? '').trim();
  return key ? key.charAt(0).toUpperCase() + key.slice(1).toLowerCase() : '';
}
